import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c0629bea&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=c0629bea&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0629bea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0629bea')) {
      api.createRecord('c0629bea', component.options)
    } else {
      api.reload('c0629bea', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c0629bea&scoped=true", function () {
      api.rerender('c0629bea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/service/Information/index.vue"
export default component.exports